import { Component, Input, OnInit } from '@angular/core';
import { FlashController } from '../../../flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-card-carousel',
  templateUrl: './card-carousel.component.html',
  styleUrls: ['../way-to-pay.component.sass']
})
export class CardCarouselComponent implements OnInit {
  @Input() canShowArrows: boolean;
  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

  test(event) {
    console.log(event);
    console.log(event.target);
    this.flashPaymentService.controller.tokenInstrumentId = 0;
    this.flashPaymentService.selectCard({id: -1});
  }


}
